/**
 * Vertical playhead line across the ruler and lanes.
 */

interface PlayheadProps {
  x: number;
}

export default function Playhead({ x }: PlayheadProps) {
  return <div className="vt-playhead" style={{ transform: `translateX(${x}px)` }} aria-hidden />;
}
